/* IU Pages 1.2.0: presentation only. Commerce and wishlist persistence stay native. */
(() => {
  const mountCart = (root) => {
    if (!root || root.dataset.iuEditorialReady) return;
    root.dataset.iuEditorialReady = 'true';
    const markPrimary = (image) => {
      if (image?.matches('.ri-img-primary') && image.naturalWidth > 0) image.classList.add('iu-primary-ready');
    };
    root.querySelectorAll('.ri-img-primary').forEach(markPrimary);
    root.addEventListener('load', (event) => markPrimary(event.target), true);
    const alignMetadata = () => {
      root.querySelectorAll('.ri-card').forEach((card) => {
        const meta = card.querySelector('.iu-related-meta');
        const material = card.querySelector('.iu-curation-material-row');
        if (meta && material && material.parentElement !== meta) meta.appendChild(material);
      });
    };
    alignMetadata();
    new MutationObserver(alignMetadata).observe(root, { childList: true, subtree: true });
    root.addEventListener('click', (event) => {
      const link = event.target.closest('.ri-image-link');
      const card = link?.closest('[data-ri-card]');
      if (!card?.classList.contains('has-secondary') || event.detail === 0 || !matchMedia('(max-width: 760px), (hover: none), (pointer: coarse)').matches) return;
      const now = Date.now();
      if (!card.classList.contains('ri-force-secondary') || now - Number(card.dataset.riTap || 0) > 2600) {
        event.preventDefault();
        root.querySelectorAll('.ri-force-secondary').forEach((item) => { if (item !== card) item.classList.remove('ri-force-secondary'); });
        card.classList.add('ri-force-secondary');
        card.dataset.riTap = String(now);
      }
    });
    try {
      window.sharedFunctions?.setLocalStorageProductForWishlist?.();
      document.dispatchEvent(new CustomEvent('wishlist:refresh', { bubbles: true }));
    } catch { /* Wishlist remains a normal product link when its native app is unavailable. */ }
  };
  window.IUPagesEditorial = { mountCart };
  const init = () => {
    document.querySelectorAll('[data-iu-cart-recommendations]').forEach((root) => {
      if (root.querySelector('.ri-card')) mountCart(root);
    });
    const favorites = document.querySelector('.iu-wishlist-page');
    if (!favorites || favorites.dataset.iuEditorialReady) return;
    favorites.dataset.iuEditorialReady = 'true';
    favorites.addEventListener('click', (event) => {
      const link = event.target.closest('.card-media .card-link');
      const media = link?.closest('.card-media');
      if (!media || media.querySelectorAll('img').length < 2 || event.detail === 0 || !matchMedia('(max-width: 760px), (hover: none), (pointer: coarse)').matches) return;
      const now = Date.now();
      if (!media.classList.contains('iu-favorite-secondary') || now - Number(media.dataset.iuTap || 0) > 2600) {
        event.preventDefault();
        favorites.querySelectorAll('.iu-favorite-secondary').forEach((item) => { if (item !== media) item.classList.remove('iu-favorite-secondary'); });
        media.classList.add('iu-favorite-secondary');
        media.dataset.iuTap = String(now);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
